if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        successMessage:this.querySelector('[data-success-message]'),
        url: this.dataset.url
      }

      if (navigator.share) {
        this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.elements.url, title: document.title }) });
      } else {
        this.elements.shareButton.addEventListener('click',this.copyToClipboard.bind(this));

      }
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.elements.url).then(() => {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          setTimeout(() => {
           this.elements.successMessage.classList.add('hidden');
          }, 2000);
      });
    }

    // Slab & Pack: product-info.js varyant degisince bunu cagiriyor; eksik oldugu icin fiyat/sepete ekle guncellenmiyordu
    updateUrl(url) {
      this.elements.url = url;
      this.dataset.url = url;
    }
  });
}
